// Supabase client for the Figjam frontend.
//
// Used for:
//   - Sign-in / sign-out via Spotify OAuth (Supabase handles the dance)
//   - Reading the current user session (user.id + Spotify provider_token)
//   - Future: per-user playlist library, jams, discovered tracks (Phase B)
//
// Env vars are loaded at build time by CRA. They MUST be prefixed with
// REACT_APP_ to be exposed to the browser bundle.
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // Don't throw — the rest of the app should still load. Auth UI just
  // won't be functional without these.
  // eslint-disable-next-line no-console
  console.warn(
    "[supabase] missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY — sign-in will fail"
  );
}

export const supabase = createClient(supabaseUrl || "", supabaseAnonKey || "");

// Expose in dev for console testing — e.g.
//   const { data } = await supabase.auth.getSession()
if (typeof window !== "undefined") {
  window.supabase = supabase;
}

// All Spotify scopes Figjam needs. Mirror of the scope string in
// /auth/spotify on the backend so functionality stays identical.
const SPOTIFY_SCOPES = [
  "user-read-recently-played",
  "user-read-currently-playing",
  "user-library-read",
  "user-library-modify",
  "user-top-read",
  "user-follow-read",
  "playlist-read-private",
  "playlist-read-collaborative",
  "playlist-modify-public",
  "playlist-modify-private",
  "streaming",
  "user-read-email",
  "user-read-private",
  "user-modify-playback-state",
].join(" ");

// Kicks off the Spotify OAuth flow via Supabase. Browser redirects to
// Spotify, user approves, redirects through Supabase, then back here
// with a session. Returns immediately (the redirect happens in the
// background).
export async function signInWithSpotify() {
  return supabase.auth.signInWithOAuth({
    provider: "spotify",
    options: {
      // After auth, Supabase redirects back to this URL.
      redirectTo: window.location.origin,
      scopes: SPOTIFY_SCOPES,
    },
  });
}

export async function signOut() {
  return supabase.auth.signOut();
}
